import { TOption } from 'components/SelectMy';

export enum GLOBAL_ROLES {
    admin = 'admin',
    customer = 'customer',
}

export enum ROLES {
    admin = 'admin',
    customer = 'customer',
    pending = 'pending',
    member = 'member',
}

export enum USER_STATUS {
    deactivated = 'deactivated',
    active = 'active',
}

export enum PLATFORMS {
    aloware = 'aloware',
    close = 'close',
}

export type TCompanyParams<MyType = void> = {
    companyId: string;
    agentId?: string;
    teamId?: string;
    data?: MyType;
};

export type TCalloutItem = {
    id?: string;
    event: null | TOption;
    service: null | TOption;
    key: string;
};

export type TStatisticITem = {
    id: number;
    timestamp: Date;
    direction: string;
    status: string;
    transfer: string;
    resolution: string;
    creator: string;
    callDisposition: string;
    leadId: string;
    recordMetadataId: string;
    date: string;
};

export type TVariables = {
    convoThresh: number;
    dialTime: number;
    textTime: number;
    workDays: number;
};

export type TTeamData = {
    id: string;
    title: string;
    companyId: string;
    Variables: TVariables;
    Agents: Array<any>;
};

export type TTeam = {
    id: string;
    title: string;
    companyId: string;
    variables: TVariables;
    members: Array<any>;
};

export type TTeamAgentsData = {
    team: {
        id: string;
        companyId: string;
        title: string;
    };
    agents: [
        {
            userId: string;
            status: string;
            available: boolean;
            lastDelegated: string;
            lastActive: string;
            maxOpenCapacity: number;
            user: {
                email: string;
                status: string;
                fullName: string;
            };
        },
    ];
};

export type TRole = {
    id: string;
    name: string;
    type: string;
};
